import React, { Component } from 'react';
import dayjs from '../../../dayjs/dayjs_timezone';
import Table from '../../components/Common/Table';
import { dateTimeFormat } from '../../utilities/timeUtility';
import { parseStatus } from '../../utilities/parser';
import Icon from '../../components/Icon';

const itemKey = (item) => `${item.external_id}_${item.start}`;

export default class ErrorTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns(),
      extraColumns: this.extraColumns(),
    };
  }

  columns() {
    const headers = ['Item', 'Message', 'Qty', 'Start'];

    const lists = this.props.items.map((item) => ({
      key: itemKey(item),
      Qty: item.quantity,
      Item: item.product_title,
      Start: this.parseStart(item),
      Message: parseStatus(item.status, this.props.translation),
    }));

    return { headers, lists };
  }

  parseStart(item) {
    const { timeZone } = window.bta;
    if (!item.start) return '';
    return item.start.length === 16 || item.start.length === 10
      ? dayjs.tz(item.start, timeZone).format(dateTimeFormat(item['all_day?']))
      : dayjs(item.start).tz(timeZone).format(dateTimeFormat(item['all_day?']));
  }

  extraColumns() {
    const attrs = this.props.items.reduce((all, item) => {
      all[itemKey(item)] = {
        style: item.status === 'ok' ? { display: 'none' } : { border: 'none', background: 'transparent' },
        key: itemKey(item),
      };
      return all;
    }, {});

    return [
      {
        attrs,
        type: 'button',
        content: <Icon iconName="trash" />,
        header: 'remove',
        onClick(e) {
          const id = e.currentTarget.name.split('_')[0];
          const key = e.currentTarget.name.split('_remove')[0];
          const line = Object.keys(attrs).indexOf(key) + 1;

          if (line) {
            window.xprops.onTrigger('removeItemByLineIndex', line);
          } else {
            window.xprops.onTrigger('removeItems', [id]);
          }
        },
      },
    ];
  }

  render() {
    const { items, show, style } = this.props;

    if (items && items.length) {
      return (
        <div
          className="ptb15 error-table"
          style={{
            display: show ? 'block' : 'none',
            borderBottom: '2px solid rgba(255, 255, 255, 0.6)',
            marginBottom: '5px',
            overflow: 'scroll',
            maxHeight: 'calc(80vh)',
          }}
        >
          <Table
            style={style.body}
            columnReverse
            className="fancy"
            items={items}
            columns={this.state.columns}
            extraColumns={this.state.extraColumns}
          />
        </div>
      );
    }
    return '';
  }
}
